import { useFormContext } from "react-hook-form";
import { PasswordFieldset } from "./components/PasswordFieldset";
import { EnterMfaCodeFieldset } from "./components/EnterMfaCodeFieldset";
import { SelectMfaMethodFieldset } from "./components/SelectMfaMethodFieldset";
import { View } from "react-native-ui-lib";
import { SwitchUserFormValues } from "./types";

export interface SwitchUserFormProps {}

export const SwitchUserForm = ({}: SwitchUserFormProps) => {
  const formContext = useFormContext<SwitchUserFormValues>();
  const { watch } = formContext;

  const watchedMfaRequired = watch("mfaRequired");
  const watchedMfaCodeSent = watch("mfaCodeSent");

  let fieldSet = <PasswordFieldset />;

  if (watchedMfaRequired) {
    if (watchedMfaCodeSent) {
      fieldSet = <EnterMfaCodeFieldset />;
    } else {
      fieldSet = <SelectMfaMethodFieldset />;
    }
  }

  return <View>{fieldSet}</View>;
};
